import reducerConstant from "common/reducerConstants";

const initialState = {
  loading: false,
  results: [],
  query: "",
  error: null,
};

const globalSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case reducerConstant.globalSearch:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case reducerConstant.globalSearchSuccess:
      return {
        ...state,
        loading: false,
        results: action.payload.response,
        query: action.payload.query,
        error: null,
      };

    case reducerConstant.globalSearchFailed:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        results: [],
      };

    case reducerConstant.clearGlobalSearch:
      return {
        ...state,
        loading: false,
        results: [],
        query: "",
        error: null,
      };

    default:
      return state;
  }
};

export default globalSearchReducer;
